<template>
  <div :class="$style.outer">
    <span :class="$style.label" :style="labelStyle">{{editable ? '附件上传' : '附件'}}：</span>
    <el-upload
      v-if="editable"
      ref="upload"
      class="upload-demo"
      action="/api/inspect/upload-file"
      :on-remove="onRemove"
      :on-error="onRemove"
      :limit="1"
      :on-success="onSuccess"
      :on-exceed="onExceed"
      :file-list="fileList">
      <el-button size="small" :class="$style.small__btn" :disabled="!!fileList.length">浏览 ...</el-button>
    </el-upload>
    <div v-else>
      <span v-if="value" @click="onDownload" :class="$style.file">
        <span >{{ form[nameProp] }}</span>
        <i :class="$style.icon" class="el-icon-download" @click="onDel(index)"></i>
      </span>
      <span v-else> -- </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: [ String, Number ],
    form: Object,
    editable: {
      type: Boolean,
      default: true
    },
    nameProp: String,
    labelStyle: String,
  },
  data() {
    return {
      fileList: []
    }
  },
  watch: {
    editable: {
      handler (val) {
        if (val && this.value) {
          this.fileList = [
            { url: this.value, name: this.form[this.nameProp]}
          ]
        }
      },
      immediate: true
    }
  },
  methods: {
    onRemove() {
      this.$emit('input', '')
      this.form[this.nameProp] = ''
      this.fileList = []
    },
    onSuccess({code, data, msg}) {
      if (code === 200) {
        this.$emit('input', data.url)
        this.form[this.nameProp] = data.filename
      } else {
        this.$message.error(msg)
        this.onRemove()
      }
    },
    onExceed () {
      this.$confirm('请先删除已上传的附件')
    },
    onDownload() {
      // 协议替换
      let value = this.value.replace('http://','https://')
      window.open(value)
      // let downloadUrl = this.value
      // let fileName = this.form[this.nameProp]

      // var xhr = new XMLHttpRequest();
      //   xhr.onreadystatechange = function () {
      //   if (this.readyState == 4 && this.status == 200) {
      //     // 创建一个Blob对象
      //     var blob = new Blob([this.response], { type: "application/pdf" });

      //     // 使用FileSaver.js库保存文件
      //     saveAs(blob, fileName);
      //   }
      // };
      // xhr.open("GET", downloadUrl);
      // xhr.responseType = "arraybuffer";
      // xhr.send();
    }
  }
}
</script>

<style lang="scss" module>
.outer {
  display: flex;
  // align-items: center;
}
.label {
  flex-shrink: 0;
}
.small__btn {
  padding: 5px 15px!important;
}
.file {
  cursor: pointer;
  color: #3285fc;
  &:hover .icon {
    opacity: 1;
  }
}

.icon {
  margin-left: 5px;
  opacity: 0;
}
</style>
